module.exports = __webpack_public_path__ + "static/media/GelBoxOpen.de52ca4c.svg";